module.exports = "/_next/static/images/loop-points-cd4530d763a9539f6569da181655db67.png";